// Legacy builds (build:apollo11, build:akasha, ...) bake REACT_APP_* via
// env-cmd + CRA's DefinePlugin — those values win when present. The docker
// build has no .env file, so process.env.REACT_APP_X is undefined and we
// fall back to window._env_, populated at container start from config.js.
export const getEnv = (key) => {
  const buildTime = process.env[key]
  if (buildTime !== undefined) return buildTime
  return window._env_ && window._env_[key]
}
